import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchBusinesses, updateDecisions, fetchBusinessesBackground, updatePage, updateSelectedBusiness } from '../../../redux/businesses'

import CenteredSpinner from '../../Atoms/Spinner/CenteredSpinner'
import InlineError from '../../Atoms/InlineError'
import Businesses from './component'

const anyVersionsChanged = (newItems, oldItems, deviceId) => {
  let hasChange = false
  newItems.forEach((newIt, i) => {
    if (newIt.version !== oldItems[i].version && newIt.updatedBy && newIt.updatedBy !== deviceId) {
      hasChange = true
    }
  })
  return hasChange
}

class BusinessesContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      decisions: null,
      readyForDisplay: false
    }
    this.lastSynced = {}
  }

  componentDidMount () {
    this.props.fetchBusinesses(this.props.teamNumber, this.props.selectedRound)
    this.pollChanges()
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
      this.checkAndUpdate()
      this.lastSynced = {}
    }
  }

  shouldComponentUpdate (nextProps) {
    if (!nextProps.isCurrentTab) {
      return false
    }
    return true
  }

  pollChanges = () => {
    this.interval = setInterval(() => {
      if (this.props.isCurrentTab) {
        this.checkAndUpdate()
        this.props.fetchBusinessesBackground(this.props.teamNumber, this.props.selectedRound)
      }
    }, 5000)
  }

  checkAndUpdate = () => {
    const changes = []
    for (const business of Object.keys(this.state.decisions)) {
      const decision = this.state.decisions[business]
      const lastSynced = this.lastSynced[business]
      if (lastSynced) {
        const newPrice1Now = parseInt(decision.price1Now)
        if (newPrice1Now !== lastSynced.price1Now) {
          changes.push({ businessId: decision.businessId, price1Now: newPrice1Now })
          lastSynced.price1Now = newPrice1Now
        }
        const newPrice2Now = parseInt(decision.price2Now)
        if (newPrice2Now !== lastSynced.price2Now) {
          changes.push({ businessId: decision.businessId, price2Now: newPrice2Now })
          lastSynced.price2Now = newPrice2Now
        }
        const newVolumeNow = parseInt(decision.volumeNow)
        if (newVolumeNow !== lastSynced.volumeNow) {
          changes.push({ businessId: decision.businessId, volumeNow: newVolumeNow })
          lastSynced.volumeNow = newVolumeNow
        }
      }
    }

    if (changes.length) {
      this.props.updateDecisions({ team: this.props.teamNumber, round: this.props.selectedRound, decisions: changes, deviceId: this.props.deviceId })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.selectedRound !== prevProps.selectedRound || this.props.roundNumber !== prevProps.roundNumber || this.props.teamNumber !== prevProps.teamNumber) {
      this.lastSynced = {}
      return this.props.fetchBusinesses(this.props.teamNumber, this.props.selectedRound)
    }
    const shouldUpdateDecisions =
      (this.props.items.length && !prevProps.items.length) ||
      (this.props.items.length && !prevState.readyForDisplay && !this.state.readyForDisplay) ||
      (this.props.items.length && prevProps.items.length && anyVersionsChanged(this.props.items, prevProps.items, prevProps.deviceId))

    if (shouldUpdateDecisions) {
      this.setState({
        readyForDisplay: true,
        decisions: this.props.items.reduce((result, item) => {
          this.lastSynced[item.type] = {
            price1Now: item.price1Now,
            price2Now: item.price2Now,
            volumeNow: item.volumeNow
          }
          result[item.type] = {
            businessId: item.id,
            price1Now: item.price1Now,
            price2Now: item.price2Now,
            volumeNow: item.volumeNow
          }
          return result
        }, {})
      })
    }
  }

  handleChangeValue = (type, field, value) => {
    if (this.state.decisions[type][field] === value) {
      return
    }
    this.setState({
      decisions: {
        ...this.state.decisions,
        [type]: {
          ...this.state.decisions[type],
          [field]: value
        }
      }
    })
  }

  handleBusinessSelect = (selectedBusiness) => {
    this.props.updateSelectedBusiness(selectedBusiness)
  }

  render () {
    if (this.props.isLoading || !this.state.readyForDisplay) {
      return <CenteredSpinner />
    }
    if (this.props.error) {
      return <InlineError message={this.props.error.message} />
    }
    if (!this.props.items.length) {
      return <InlineError message={`No decisions have been uploaded for round ${this.props.selectedRound}`} />
    }
    return (
      <Businesses
        items={this.props.items}
        selectedBusiness={this.props.selectedBusiness}
        onBusinessSelect={this.handleBusinessSelect}
        decisions={this.state.decisions}
        onChangeValue={this.handleChangeValue}
        selectedRound={this.props.selectedRound}
        enableChanges={this.props.enableChanges}
        currentPage={this.props.currentPage}
        updatePage={this.props.updatePage}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  isCurrentTab: state.ui.currentTab === 'Businesses',
  currentPage: state.businesses.currentPage,
  enableChanges: state.game.selectedRound === state.game.currentRound,
  deviceId: state.device.deviceId,
  teamNumber: state.team.id,
  selectedRound: state.game.selectedRound,
  roundNumber: state.game.currentRound,
  isLoading: state.businesses.isLoading,
  isLoaded: state.businesses.isLoaded,
  error: state.businesses.error,
  items: state.businesses.businesses,
  selectedBusiness: state.businesses.selectedBusiness
})

export default connect(mapStateToProps, {
  fetchBusinesses,
  updateDecisions,
  fetchBusinessesBackground,
  updatePage,
  updateSelectedBusiness
})(BusinessesContainer)
